import { NavLink } from "react-router-dom";
import { useAuth } from "../context/AuthContext";
import { SquaresFour, ListChecks, PlusCircle, Receipt, UserCircle, SignOut, Wrench } from "@phosphor-icons/react";

const NAV = [
  { to: "/account", label: "Dashboard", icon: SquaresFour, end: true },
  { to: "/account/requests", label: "My Requests", icon: ListChecks },
  { to: "/account/new", label: "Book Service", icon: PlusCircle },
  { to: "/account/invoices", label: "Invoices", icon: Receipt },
  { to: "/account/profile", label: "My Profile", icon: UserCircle },
];

export function CustomerLayout({ children }) {
  const { user, logout } = useAuth();
  return (
    <div className="flex min-h-screen bg-background">
      <aside className="w-64 shrink-0 border-r border-border bg-card flex flex-col fixed h-screen" data-testid="customer-sidebar">
        <div className="h-16 flex items-center gap-2 px-6 border-b border-border">
          <div className="w-8 h-8 bg-primary rounded-sm flex items-center justify-center">
            <Wrench size={18} weight="bold" className="text-primary-foreground" />
          </div>
          <span className="font-heading font-bold text-lg tracking-tight">Fixigo</span>
          <span className="label-caps text-[9px] mt-1">Account</span>
        </div>
        <nav className="flex-1 py-4 px-3 space-y-1 overflow-y-auto">
          {NAV.map((n) => (
            <NavLink key={n.to} to={n.to} end={n.end}
              data-testid={`cnav-${n.label.toLowerCase().replace(" ", "-")}`}
              className={({ isActive }) =>
                `flex items-center gap-3 px-3 py-2.5 rounded-sm text-sm font-medium transition-colors duration-200 ${
                  isActive ? "bg-primary text-primary-foreground" : "text-muted-foreground hover:bg-secondary hover:text-foreground"
                }`}>
              <n.icon size={18} weight="bold" /> {n.label}
            </NavLink>
          ))}
        </nav>
        <div className="border-t border-border p-3">
          <div className="px-3 py-2 mb-1">
            <div className="text-sm font-semibold truncate" data-testid="customer-name">{user?.name}</div>
            <div className="text-xs text-muted-foreground uppercase tracking-wide">Customer</div>
          </div>
          <button data-testid="customer-logout" onClick={logout}
            className="flex items-center gap-3 w-full px-3 py-2.5 rounded-sm text-sm font-medium text-destructive hover:bg-destructive/10 transition-colors duration-200">
            <SignOut size={18} weight="bold" /> Sign out
          </button>
        </div>
      </aside>
      <main className="flex-1 ml-64 min-w-0">{children}</main>
    </div>
  );
}
